<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
<script>
	import Entries from "./Entries.svelte"
	import { Router, Route, navigate } from "svelte-routing";
	import QrPage from "./QrPage.svelte";
	import { tick } from "svelte";

	navigate('#');

	let message;
	async function receive(ev) {
		message = ev.detail;
		await tick()
		navigate("#secrets");
	}

	function move(ev) {
		navigate("#secrets/" + ev.detail)
	}
</script>

<main>
	<div style="display: flex; flex-direction: column; align-items:center; height: inherit;">
		<Router>
			<Route path="#secrets/*route" let:params>
				{#if message.children}
					<Entries entries={message} route={params.route} on:navigate={move}></Entries>
				{/if}
			</Route>
			<Route path="/">
				<QrPage on:message={receive}/>
			</Route>
		</Router>
	</div>
</main>

<style>
	main {
		margin: 0 auto;
		height: inherit;
		min-width: 200px;
		overflow: auto;
		background-color: #f8f8f8;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>